export const BASE_CATEGORIES_URL = 'v1/categories';

export const CATEGORIES_OPTIONS_URL = `${BASE_CATEGORIES_URL}/options`;
